import React, { useMemo } from 'react'
import { Card, FlexView, Spinner } from 'components/common'
import { ResponsiveContainer, PieChart, Pie, Tooltip, Cell } from 'recharts'
import _ from 'lodash'

const COLORS = ['#72aeff', '#3ac5de', '#46c7a8', '#68c17a', '#99b65f', '#ff9661', '#ff8a7e', '#ff87ab', '#f18ee1', '#b19dff']
const RADIAN = Math.PI / 180
const renderCustomizedLabel = ({
  cx, cy, midAngle, innerRadius, outerRadius, percent, index,
}) => {
  const radius = innerRadius + (outerRadius - innerRadius) * 1.1
  const x = cx + radius * Math.cos(-midAngle * RADIAN)
  const y = cy + radius * Math.sin(-midAngle * RADIAN)

  return (
    <text x={x} y={y} fill="black" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central" fontSize="14">
      {percent >= 0.03 && `${(percent * 100).toFixed(0)}%`}
    </text>
  )
}

const PiecesPieChartCard = ({ isLoading, pieces, title, ...rest }) => {

//  const formatPrice = (value) => {
//    return Number.parseFloat(value).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
//  }
  const totalPieces = useMemo(() => _.sumBy(pieces, 'value'), [pieces])
  const CustomTooltip = () => ({ active, payload }) => active ? (
    <Card padding="8px" maxWidth="500px">
      <FlexView margin="4px" fontWeight="bold">{payload[0].name}</FlexView>
      <FlexView margin="4px"> {`${payload[0].payload.value}`}</FlexView>
      <FlexView margin="4px" color="metalic">{`${payload[0].value} - (${((payload[0].value / totalPieces) * 100).toFixed(2)}%)`}</FlexView>
    </Card>
  ) : null

  return <Card style={{ overflow: 'hidden' }} {...rest}>
    <FlexView fontSize="big" fontWeight="bold" margin="0px 0px 16px">{title}</FlexView>
    {isLoading && pieces.length === 0 ?
      <FlexView justifyContent="center" alignItems="center" width="100%" height="100%">
        <Spinner />
      </FlexView>
      :
      <ResponsiveContainer width="99%">
        <PieChart>
          <Pie
            data={pieces}
            labelLine={false}
            label={renderCustomizedLabel}
            fill="#8884d8"
            dataKey="value">
            {
              pieces.map((entry, index) => <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />)
            }
          </Pie>
          <Tooltip content={CustomTooltip()} />
        </PieChart>
      </ResponsiveContainer>
    }
  </Card>
}

export default PiecesPieChartCard